import { PlayerPosition, PlayerStatus } from "src/app/enums/Index";
import { Model } from "./Model";
import { Sponsor, Team } from "./Index";

export interface ServiceContract extends Model {
	description: string;
	effectiveDate: Date;
	endDate: Date;
	noticePeriod: number;
	relatedFiles: string;
	serviceProvider: string;
}

export class ServiceContract implements ServiceContract {

	constructor(data?: Partial<ServiceContract>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}